<template>
  <div class="not-found">
    <div class="subpage-header">
      <h2 class="normal" id="page-title-for-sr">
        <span class="sr-only">{{ $t('confirmation.pageTitle') }}: </span>
        <span aria-live="assertive" role="status" v-html="$t('confirmation.notFound.header')"></span>
      </h2>
    </div>
    <p v-html="$t('confirmation.notFound.description')"></p><p v-html="$t('confirmation.notFound.description2')"></p>
  </div>
</template>
<script>
export default {
  name: 'ConfirmationNotFound'
}
</script>
